/**
 * Default brand landing palette — shared across marketing pages and app chrome.
 * Source of truth: hex values and gradient presets.
 * CSS variables: see `landing.css` in this pack (`--landing-*`).
 */

export const LANDING_CSS_VARS = {
  ink: '--landing-ink',
  inkMuted: '--landing-ink-muted',
  inkSecondary: '--landing-ink-secondary',
  inkNav: '--landing-ink-nav',
  inkPlaceholder: '--landing-ink-placeholder',
  brandPrimary: '--landing-brand-primary',
  brandPrimaryAlt: '--landing-brand-primary-alt',
  brandPrimaryDeep: '--landing-brand-primary-deep',
  accentOnDark: '--landing-accent-on-dark',
  navHoverText: '--landing-nav-hover-text',
  surfacePageStart: '--landing-surface-page-start',
  surfacePageMid: '--landing-surface-page-mid',
  surfacePageEnd: '--landing-surface-page-end',
  surfaceCtaStart: '--landing-surface-cta-start',
  surfaceCtaMid: '--landing-surface-cta-mid',
  surfaceCtaEnd: '--landing-surface-cta-end',
  surfaceGlass: '--landing-surface-glass',
  surfaceGlassStrong: '--landing-surface-glass-strong',
  gradientPage: '--landing-gradient-page',
  gradientBrand: '--landing-gradient-brand',
  gradientBrandHorizontal: '--landing-gradient-brand-horizontal',
  gradientBrandButton: '--landing-gradient-brand-button',
  gradientIridescentStrip: '--landing-gradient-iridescent-strip',
  gradientCtaOverlay: '--landing-gradient-cta-overlay',
  gradientCtaBackdrop: '--landing-gradient-cta-backdrop',
  gradientCarouselDot: '--landing-gradient-carousel-dot',
  gradientJourneyIcon: '--landing-gradient-journey-icon',
  gradientLogo: '--landing-gradient-logo',
} as const;

/** Solid colors (hex) */
export const landingColors = {
  // Inline brand ramp for the hero headline and CTA button.
  brandRampStart: '#00B8F5',
  brandRampMid: '#0E94C9',
  brandRampEnd: '#0078B5',
} as const;

/** Gradient presets used on the landing page */
export const landingGradients = {
  page: 'var(--landing-gradient-page)',
  brand: 'var(--landing-gradient-brand)',
  brandHorizontal: 'var(--landing-gradient-brand-horizontal)',
  brandButton: 'var(--landing-gradient-brand-button)',
  iridescentStrip: 'var(--landing-gradient-iridescent-strip)',
  ctaOverlay: 'var(--landing-gradient-cta-overlay)',
  ctaBackdrop: 'var(--landing-gradient-cta-backdrop)',
  carouselDot: 'var(--landing-gradient-carousel-dot)',
  journeyIcon: 'var(--landing-gradient-journey-icon)',
  logo: 'var(--landing-gradient-logo)',
  /** Inline-friendly (no CSS var dependency) */
  brandInline: `linear-gradient(95deg, ${landingColors.brandRampStart} 0%, ${landingColors.brandRampMid} 50%, ${landingColors.brandRampEnd} 100%)`,
  brandButtonInline: `linear-gradient(95deg, ${landingColors.brandRampStart} 0%, ${landingColors.brandRampMid} 55%, ${landingColors.brandRampEnd} 100%)`,
  pageInline:
    'linear-gradient(115deg, #EDF7FC 0%, #E7F3FB 22%, #E1F1FA 42%, #DCEFF9 62%, #E6F4FB 82%, #F5FBFE 100%)',
} as const;
